import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getGoodsCategory = createAsyncThunk(
  "admin/goods-category",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/goods-category", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getGoodsCategoryById = createAsyncThunk(
  "admin/goods-category/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/goods-category/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortGoodsCategory = createAsyncThunk(
  "admin/goods-category/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/goods-category/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postGoodsCategory = createAsyncThunk(
  "admin/goods-category/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/goods-category", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteGoodsCategory = createAsyncThunk(
  "admin/goods-category/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/goods-category/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateGoodsCategory = createAsyncThunk(
  "admin/goods-category/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/goods-category/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const goodsCategorySlice = createSlice({
  name: "Customer Region Store",
  initialState: initialState,
  reducers: {
    addGoodsCategory(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortGoodsCategory(state, action) {
      state.data.docs = action.payload;
    },
    deleteGoodsCategory(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editGoodsCategory(state, action) {
        let index = state.data.docs.findIndex(item => item._id === action.payload._id);
        state.data.docs[index] = action.payload;
    },
  },
  extraReducers: {
    [getGoodsCategory.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getGoodsCategory.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getGoodsCategory.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getGoodsCategoryById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getGoodsCategoryById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getGoodsCategoryById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortGoodsCategory.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortGoodsCategory.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortGoodsCategory.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postGoodsCategory.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postGoodsCategory.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postGoodsCategory.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteGoodsCategory.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteGoodsCategory.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteGoodsCategory.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateGoodsCategory.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateGoodsCategory.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateGoodsCategory.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const goodsCategoryActions = goodsCategorySlice.actions;

export default goodsCategorySlice.reducer;
